import { BaseFlexibleConfig } from '../base-flexible-config';

export interface BrainSafetyConfigModel extends BaseFlexibleConfig {
    hideVisitHistory?: string;
    imageViewerConfiguration?: string;
    visit?: any[];
}

export enum VisitStatus {
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    NEW_NOT_EDITABLE = 'NEW_NOT_EDITABLE',
    NEW_EDITABLE = 'NEW_EDITABLE',
    IN_PROGRESS = 'IN_PROGRESS',
    DONE = 'DONE'
}